/* eslint-disable camelcase */
/* eslint-disable object-curly-newline */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useRef, useEffect, useState } from 'react';
import { Form } from '@unform/web';
// import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { MdModeEdit, MdDelete } from 'react-icons/md';

import Input from '~/components/Input';
import ImageInput from '~/pages/Admin/Modules/ImageInput';
import { Container, Header, Row, ButtonTest } from './styles';

import history from '~/services/history';
import api from '~/services/api';

export default function Cards() {
  const formRef = useRef(null);
  const [subjects, setSubjects] = useState([]);
  useEffect(() => {
    async function getData() {
      const { data } = await api.get('/subjects');
      setSubjects(data);
    }

    getData();
  }, [subjects]);

  async function handleSubmit(data, { reset }) {
    const { title, description, position, type, file_id } = data;

    if (title && description && position && type && file_id) {
      await api.post('/subjects', data);
      // reset();
      return toast.success('Subject cadastrado com sucesso');
    }
    return toast.error('Preencha todos os campos');
  }

  async function handleDelete(id) {
    await api.delete(`subjects/${id}`);
    return toast.success('Subject deletado com sucesso');
  }

  return (
    <>
      <Header>
        <ButtonTest type="submit" onClick={() => history.push('/level')}>
          <h2>Level</h2>
        </ButtonTest>
        <ButtonTest
          selected
          type="submit"
          onClick={() => history.push('/subject')}
        >
          <h2>Subject</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/module')}>
          <h2>Modules</h2>
        </ButtonTest>

        {/* <ButtonTest type="submit" onClick={() => history.push('/card')}>
          <h2>Cards</h2>
        </ButtonTest> */}

        <ButtonTest type="submit" onClick={() => history.push('/challenge')}>
          <h2>Challenges</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/jobs')}>
          <h2>Jobs</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/file')}>
          <h2>Files</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/users')}>
          <h2>Users</h2>
        </ButtonTest>
      </Header>

      <Container>
        <h1>Cadastre Matéria:</h1>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <div
            style={{
              marginLeft: 30,
            }}
          >
            <p style={{ fontSize: 20, marginLeft: -50, marginBottom: 10 }}>
              Escolha uma imagem:
            </p>
            <ImageInput name="file_id" />
          </div>
          <div className="support">
            <Input name="title" type="text" placeholder="Título" />
            <Input
              name="position"
              type="text"
              placeholder="Posiçāo da Matéria"
            />
            <span>development, business, project ou apollo</span>
            <Input name="type" type="text" placeholder="Categoria" />

            <Input
              name="description"
              type="text"
              placeholder="Descreva o significado"
            />
          </div>
          <button className="form" type="submit">
            CADASTRAR
          </button>
        </Form>
      </Container>

      <Container>
        <h1>Listagem de Matéria:</h1>
        {subjects.map((subject) => (
          <Row key={subject.id}>
            <div className="title">
              <h3>
                #{subject.id}:{subject.title}
              </h3>
            </div>
            <div className="description">
              <p>{subject.description}</p>
            </div>
            <div className="button">
              <button
                type="submit"
                className="row"
                onClick={() => history.push(`/subjectupdate/${subject.id}`)}
              >
                <MdModeEdit size={20} color="#090f35" />
              </button>
              <button
                type="submit"
                className="row"
                onClick={() => handleDelete(subject.id)}
              >
                <MdDelete size={20} color="#FF0000" />
              </button>
            </div>
          </Row>
        ))}
      </Container>
    </>
  );
}
